import { render, staticRenderFns } from "./HomeRouter.vue?vue&type=template&id=09640bfa&"
import script from "./HomeRouter.vue?vue&type=script&lang=js&"
export * from "./HomeRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports